export default __webpack_public_path__ + "book_details-grade_level.3955b165.png";